import React from 'react';

const CYCLE = require('../../../../images/landing-pages/angel-networks/about-cycle.png');

/**
 * The "Your Angel Network" virtuous-cycle graphic, sitting between the problem framing and the
 * three flows. Reason: the diagram is supplied as artwork rather than markup, so its five labels
 * live in the image — the alt text carries them for anyone who cannot see it.
 */
const AngelValueCycleSection = () => (
    <section className="lp-an-cycle-sec">
        <h2 className="lp-an-cycle-head" data-lp-reveal>
            Adding value through your <span>Network</span>
        </h2>
        <p className="lp-an-cycle-sub" data-lp-reveal data-lp-delay="80">
            Improved network portfolio returns, improved network reputation
        </p>
        <img
            className="lp-an-cycle-art"
            src={CYCLE}
            alt="Your Angel Network cycle: 1 effective due diligence, 2 at-a-glance certification, 3 more investors will invest, 4 improved angel network reputation, 5 more investors and more good quality companies"
            data-lp-reveal
            data-lp-delay="160"
        />
    </section>
);

export default AngelValueCycleSection;
